export const LOGIN_FORM_NAME = 'LoginForm';
export const RESET_PASSWORD_FORM_NAME = 'ResetPasswordForm';
export const ACCOUNT_SETUP_FORM_NAME = 'StudentInfoForm';
export const ACCOUNT_SETUP_CONTACT_FORM_NAME = 'StudentContactInfoForm';
export const DISTRICT_INFORMATION_FORM_NAME = 'DistrictInformationForm';
export const DISTRICT_SETTINGS_FORM_NAME = 'DistrictSettingsForm';
export const EDIT_CASE_TYPE_FORM_NAME = 'EditCaseTypeForm';
export const CHARGE_PERMISSION_FORM_NAME = 'ChargePermissionForm';
export const USER_ACCESS_ROLE_FORM = 'UserAccessRoleForm';
export const SCHOOL_CALENDAR_FORM_NAME = 'SchoolCalendarForm';
export const SCHOOL_CALENDAR_EXCEPTION_FORM_NAME =
  'SchoolCalendarExceptionForm';
export const VERIFICATION_CONFIGURATION_FORM_NAME =
  'VerificationConfigurationForm';
export const APPLICATION_HUB_CONTACT_INFO_FORM_NAME =
  'ApplicationContactInfoForm';
export const APPLICATION_HUB_HEADER_FORM_NAME = 'ApplicationHubHeaderForm';
export const APPLICATION_MEMBER_FORM_NAME = 'ApplicationMemberForm';
export const APPLICATION_STUDENT_FORM_NAME = 'ApplicationStudentForm';
export const APPLICATION_HOH_FORM_NAME = 'ApplicationHoHForm';
export const APPLICATION_HUB_APP_INFO_FORM_NAME =
  'ApplicationInformationFormName';
export const IMPORT_SITE_FORM_NAME = 'ImportSiteForm';
export const TRANSACTION_HISTORY_FORM_NAME = 'TransactionHistoryForm';
export const TRANSACTION_HISTORY_BY_DATE_FORM_NAME =
  'TransactionHistoryByDateForm';
export const TRANSACTION_HISTORY_BY_STUDENT_FORM_NAME =
  'TransactionHistoryByStudentForm;';
export const TEACHER_ROLLS_FORM_NAME = 'TeacherRollsForm';
export const CREDIT_CARD_PAYMENT_FORM_NAME = 'CreditCardPaymentForm';
export const BILLING_ACCOUNT_FORM_NAME = 'BillingAccountForm';
export const SPECIAL_MESSAGE_FORM_NAME = 'SpecialMessageForm';
export const STUDENT_ALLERGIES_FORM_NAME = 'StudentAllergiesForm';
export const IMPORT_LOG_FORM_NAME = 'ImportLogForm';
export const IMPORT_LICENSE_FORM = 'ImportLicenseForm';
export const DC_IMPORT_SETTINGS_FORM = 'DCSettingsForm';
export const REIMBURSEMENT_RATE_FORM = 'ReimbursementRatesForm';
export const MEAL_SUMMARY_FORM_NAME = 'MealSummaryForm';
export const MANAGE_CYCLE_MENUS_FORM_NAME = 'MANAGE_CYCLE_MENUS_FORM_NAME';
export const MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME =
  'MANAGE_CYCLE_MENUS_DETAILS_FORM_NAME';
export const APPLIED_MENU_LIST_FORM_NAME = 'APPLIED_MENU_LIST_FORM_NAME';

export const InputMode = {
  Integer: 'integer',
  Decimal: 'decimal',
  String: 'string',
  Alphanumeric: 'alphanumeric',
};

export const LANGUAGE_SETUP_FORM_NAME = 'LanguageSetupForm';
export const ITEM_SUMMARY_FORM_NAME = 'ItemSetupForm';
export const DEMOGRAPHICS_REPORT_FORM_NAME = 'DemographicsReportForm';
export const CASE_TYPE_REPORT_FORM_NAME = 'CaseTypeReportForm';
export const UNCLOSED_DATES_REPORT_FORM_NAME = 'UnclosedDatesReportForm';
export const CHECKS_SUMMARY_REPORT_FORM_NAME = 'ChecksSummaryReportForm';
export const PARTICIPATION_REPORT_FORM_NAME = 'ParticipationReportForm';
export const VERIFICATION_REPORT_FORM_NAME = 'VerificationReportFrom';
export const REIMBURSEMENT_REPORT_FORM_NAME = 'ReimbursementReportForm';
export const RECEIPTS_COLLECTIONS_REPORT_FORM_NAME =
  'ReceiptsAndCollectionsReportForm';
export const VERIFICATION_SELECTION_FORM_NAME = 'VerificationSelectionForm';
export const REVENUE_SUMMARY_REPORT_FORM_NAME = 'RevenueSummaryReportForm';
export const ACCUCLAIM_EDIT_REPORT_FORM_NAME = 'AccuclaimEditReportForm';
export const CHARGES_AND_PREPAYMENTS_REPORT_FORM_NAME =
  'ChargesAndPrepaymentsReportForm';
export const CEP_FUNDS_DUE_REPORT_FORM_NAME = 'CEPFundsDueReportForm';
export const UNAPPLIED_STUDENTS_REPORT_FORM_NAME =
  'UnappliedStudentsReportForm';
export const LETTER_HISTORY_REPORT_POINT_OF_SALE_MODE_FORM_NAME =
  'LetterHistoryReportPointOfSaleModeForm';
export const LETTER_HISTORY_REPORT_FREE_AND_REDUCED_MODE_FORM_NAME =
  'LetterHistoryReportFreeAndReducedModeForm';
export const VERIFICATION_RESULTS_LETTERS_FORM_NAME =
  'VerificationResultsLettersForm';
export const SELECTION_LETTERS_FORM_NAME = 'SelectionLettersForm';
export const STATUS_CHANGE_REPORT_FORM_NAME = 'StatusChangeReportForm';
export const EDIT_SERVED_ITEM_FORM_NAME = 'EditServedItemForm';
export const MONTHLY_CLAIM_FORM_FORM_NAME = 'MonthlyClaimFormForm';
export const MASTER_ROSTER_FORM_NAME = 'MasterRosterForm';
export const NOTIFICATION_AND_DIRECT_CERTIFIED_LETTERS_FORM_NAME =
  'NotificationAndDirectCertifiedLettersForm';
export const MBE_NOTIFICATION_LETTERS_FORM_NAME = 'MBENotificationLettersForm';
export const USER_PROFILE_FORM_NAME = 'UserProfileForm';
export const ID_CARDS_FORM_NAME = 'IdCardsForm';
export const SERVING_CONFIGURATION_FORM_NAME = 'ServingConfigurationForm';
export const VENDOR_FORM_NAME = 'VendorForm';
export const ITEM_MAINTENANCE_FORM = 'ItemMaintenanceForm';
export const ITEM_MAINTENANCE_DETAIL_FORM_NAME =
  'ItemMaintenanceDetailFormName';
export const ITEM_MAINTENANCE_BID_PRICE_FORM_NAME =
  'ItemMaintenanceBidPriceFormName';
export const ITEM_MAINTENANCE_FIFO_FORM_NAME = 'ItemMaintenanceFifoFormName';
export const VENDOR_ELECTRONIC_FILE_CONFIG_NAME =
  'VendorElectronicFileConfigForm';
export const ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME =
  'ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME';
export const CEP_SETUP_FORM_NAME = 'CEP_SETUP_FORM';
export const DAILY_DEPOSIT_FORM_NAME = 'DAILY_DEPOSIT_FORM_NAME';
export const LETTERS_FORM_NAME = 'LettersForm';
export const UNCLOSE_DAY_FORM_NAME = 'UncloseDayForm';
export const GENERIC_EXPORT_FORM_NAME = 'GenericExportForm';
export const GENERIC_EXPORT_SETUP_FORM_NAME = 'GenericExportSetupForm';
export const ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME =
  'ASSIGN_SERVED_ITEMS_TO_SITE_FORM_NAME';
export const ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME =
  'ASSIGN_SITES_TO_SERVED_ITEM_FORM_NAME';
export const EDIT_DAILY_DEPOSIT_FORM_NAME = 'EDIT_DAILY_DEPOSIT_FORM_NAME';
export const EDIT_DAILY_DEPOSIT_SALES_TABLE_MODAL_FORM_NAME =
  'EDIT_DAILY_DEPOSIT_SALES_TABLE_MODAL_FORM_NAME';
export const MANAGE_PROCESS_ORDER_FORM_NAME = 'MANAGE_PROCESS_ORDER_FORM_NAME';
export const CREATE_EDIT_ORDER_FORM = 'CREATE_EDIT_ORDER_FORM';
export const PURCHASE_ORDER_INFO_FORM_NAME = 'PURCHASE_ORDER_INFO_FORM_NAME';
export const CEP_BULK_PROCESSING_FORM_NAME = 'CEP_BULK_PROCESSING_FORM';
export const TRANSACTION_FORM_NAME = 'TRANSACTION_FORM_NAME';
export const OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME =
  'OHIO_DAILY_WORKSHEET_REPORT_FORM_NAME';
export const OHIO_CASH_RECEIPTS_REPORT_FORM_NAME =
  'OHIO_CASH_RECEIPTS_REPORT_FORM_NAME';
export const PROCESS_ORDER_FORM_NAME = 'PROCESS_ORDER_FORM_NAME';
export const ROSTER_CURRENT_BALANCE_FORM_NAME =
  'ROSTER_CURRENT_BALANCE_FORM_NAME';
export const IMPORT_SETTINGS = 'ImportSettings';
export const AUTO_IMPORT_SETUP = 'AutoImportSetup';

export const MANAGE_PURCHASE_ORDER_FORM_NAME =
  'MANAGE_PURCHASE_ORDER_FORM_NAME';
export const CREATE_EDIT_TRANSFER_FORM_NAME = 'CREATE_EDIT_TRANSFER_FORM_NAME';
export const TRANSFER_ORDER_FORM_NAME = 'TRANSFER_ORDER_FORM_NAME';
export const CREATE_EDIT_PURCHASE_ORDER_FORM_NAME =
  'CREATE_EDIT_PURCHASE_ORDER_FORM_NAME';
export const CREATE_EDIT_RECEIPT_INVENTORY_FORM_NAME =
  'CREATE_EDIT_RECEIPT_INVENTORY_FORM_NAME';
export const UPDATE_CEP_COUNTS_FORM_NAME = 'UPDATE_CEP_COUNTS_FORM_NAME';
export const SERVED_ITEMS_COLOR_SETUP_FORM_NAME =
  'SERVED_ITEMS_COLOR_SETUP_FORM_NAME';
export const UPDATE_BID_DETAILS_FORM_NAME = 'UPDATE_BID_DETAILS_FORM_NAME';
export const ASSIGN_ITEMS_FORM_NAME = 'ASSIGN_ITEMS_FORM_NAME';
export const USAGE_LIST_FORM_NAME = 'USAGE_LIST_FORM_NAME';
export const CREATE_EDIT_USAGE_FORM_NAME = 'CREATE_EDIT_USAGE_FORM_NAME';
export const UPDATE_BID_PRICE_DETAILS_FORM_NAME =
  'UPDATE_BID_PRICE_DETAILS_FORM_NAME';
export const CONSOLIDATE_FORM_NAME = 'CONSOLIDATE_FORM_NAME';
export const ADJUSTMENT_LIST_FORM_NAME = 'ADJUSTMENT_LIST_FORM_NAME';
export const PHYSICAL_FORM_NAME = 'PHYSICAL_FORM_NAME';
export const CREATE_EDIT_PHYSICAL_FORM_NAME = 'CREATE_EDIT_PHYSICAL_FORM_NAME';
export const CREATE_EDIT_ADJUSTMENT_FORM_NAME =
  'CREATE_EDIT_ADJUSTMENT_FORM_NAME';

export const ASSIGN_ENTITIES_FORM_NAME = 'ASSIGN_ENTITIES_FORM_NAME';
export const ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME =
  'ASSIGN_ENTITIES_STORAGE_LOCATION_FORM_NAME';
export const CUSTOM_QUERY_FORM_NAME = 'CUSTOM_QUERY_FORM_NAME';
export const TRANSACTION_SUMMARY_LIST_FORM_NAME =
  'TRANSACTION_SUMMARY_LIST_FORM_NAME';
export const CREATE_TRANSACTION_FORM_NAME = 'CREATE_TRANSACTION_FORM_NAME';
export const EDIT_MENU_FORM_NAME = 'EDIT_MENU_FORM_NAME';
export const UPDATE_OPEN_ORDERS_FORM_NAME = 'UPDATE_OPEN_ORDERS_FORM_NAME';
export const ITEM_STORAGE_LOCATION_FORM_NAME =
  'ITEM_STORAGE_LOCATION_FORM_NAME';
export const IMPORT_ITEMS_FORM_NAME = 'IMPORT_ITEMS_FORM_NAME';
export const EXPORT_ITEMS_FORM_NAME = 'EXPORT_ITEMS_FORM_NAME';
export const APPLY_CYCLE_MENU_FORM_NAME = 'APPLY_CYCLE_MENU_FORM_NAME';
export const UN_APPLY_CYCLE_MENU_FORM_NAME = 'UN_APPLY_CYCLE_MENU_FORM_NAME';
export const OPEN_ORDERS_REPORT_FORM_NAME = 'OPEN_ORDERS_REPORT_FORM_NAME';
export const ORDER_REPORT_FORM_NAME = 'ORDER_REPORT_FORM_NAME';
export const ITEM_LISTING_FORM_NAME = 'ITEM_LISTING_FORM_NAME';
export const PHYSICAL_INVENTORY_FORM_NAME = 'PHYSICAL_INVENTORY_FORM_NAME';
export const ON_HAND_REPORT_LISTING_FORM_NAME =
  'ON_HAND_REPORT_LISTING_FORM_NAME';
export const ON_HAND_REPORT_FIFO_FORM_NAME = 'ON_HAND_REPORT_FIFO_FORM_NAME';
export const ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME =
  'ON_HAND_REPORT_TRANSACTION_DETAILS_FORM_NAME';
export const WAREHOUSE_KITCHEN_HOLD_FORM_NAME =
  'WAREHOUSE_KITCHEN_HOLD_FORM_NAME';
export const WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME =
  'WAREHOUSE_KITCHEN_AVAILABILITY_FORM_NAME';
export const WAREHOUSE_KITCHEN_LOAD_FORM_NAME =
  'WAREHOUSE_KITCHEN_LOAD_FORM_NAME';
export const TRANSACTION_HISTORY_REPORT_FORM_NAME =
  'TRANSACTION_HISTORY_REPORT_FORM_NAME';
export const RECIPE_TABLE_FORM_NAME = 'RECIPE_TABLE_FORM_NAME';
export const POWERSCHOOL_INTEGRATION_FORM_NAME =
  'POWERSCHOOL_INTEGRATION_FORM_NAME';
export const POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME =
  'POWERSCHOOL_EXPORT_CONFIGURATION_FORM_NAME';
export const INTEGRATION_PREVIEW_FORM_NAME = 'INTEGRATION_PREVIEW_FORM_NAME';
export const MAPPING_MODAL_FORM_NAME = 'MAPPING_MODAL_FORM_NAME';
export const EDIT_RECIPE_FORM_NAME = 'EDIT_RECIPE_FORM_NAME';
export const IMPORT_PICTURES_FORM_NAME = 'IMPORT_PICTURES_FORM_NAME';
export const ASSIGN_ORDER_PREFERENCE_FORM_NAME =
  'ASSIGN_ORDER_PREFERENCE_FORM_NAME';
export const CLOSE_SCHOOL_YEAR_DOWNLOAD_ROSTER_FORM_NAME =
  'CLOSE_SCHOOL_YEAR_DOWNLOAD_ROSTER_FORM_NAME';
export const INGREDIENT_TABLE_FORM_NAME = 'INGREDIENT_TABLE_FORM_NAME';
export const EDIT_INGREDIENT_FORM_NAME = 'EDIT_INGREDIENT_FORM_NAME';
export const CLOSE_SCHOOL_YEAR_FORM_NAME = 'CLOSE_SCHOOL_YEAR_FORM_NAME';
export const MANAGE_KITCHEN_ITEM_FORM_NAME = 'MANAGE_KITCHEN_ITEM_FORM_NAME';
export const CK_KITCHEN_PREP_WORKSHEET_FORM_NAME =
  'CK_KITCHEN_PREP_WORKSHEET_FORM_NAME';
export const MEALS_EQUIVALENT_SETUP_FORM_NAME =
  'MEALS_EQUIVALENT_SETUP_FORM_NAME';
export const ING_MEASUREMENTS_FORM_NAME = 'ING_MEASUREMENTS_FORM_NAME';
export const ING_PURCHASING_FORM_NAME = 'ING_PURCHASING_FORM_NAME';
export const TAX_RATES_BY_STATUS_FORM_NAME = 'TAX_RATES_BY_STATUS_FORM_NAME';
export const CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME =
  'CK_KITCHEN_PREP_WORKSHEET_CREATE_EDIT_FORM_NAME';
export const IMPORT_INGREDIENT_FORM_NAME = 'IMPORT_INGREDIENT_FORM_NAME';
export const ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME =
  'ELIGIBILITY_BY_APPLICATION_REPORT_FORM_NAME';
export const CONTROL_INFO_MENUS_FORM_NAME = 'CONTROL_INFO_MENUS_FORM_NAME';
export const HACCP_TYPE_FORM_NAME = 'HACCP_TYPE_FORM_NAME';
export const HACCP_FORM_NAME = 'HACCP_FORM_NAME';
export const RECIPE_GROUPS_FORM_NAME = 'RECIPE_GROUPS_FORM_NAME';
export const PRODUCTION_PLAN_FORM_NAME = 'PRODUCTION_PLAN_FORM_NAME';
export const INGREDIENT_GROUPS_FORM_NAME = 'INGREDIENT_GROUPS_FORM_NAME';
export const RECIPE_PREPARATION_FORM_NAME = 'RECIPE_PREPARATION_FORM_NAME';
export const FAMILY_MATCH_UTILITY_FORM_NAME = 'FAMILY_MATCH_UTILITY_FORM_NAME';
export const CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME =
  'CK_AVAILABLE_KITCHEN_PREP_WORKSHEET_FORM_NAME';
export const CREATE_EDIT_TRUCK_ROUTE_FORM_NAME =
  'CREATE_EDIT_TRUCK_ROUTE_FORM_NAME';
export const DISCREPANCY_REPORT_FORM_NAME = 'DISCREPANCY_REPORT_FORM_NAME';
export const CK_PRINT_BARCODES_FORM_NAME = 'CK_PRINT_BARCODES_FORM_NAME';
export const UNIVERSAL_DATA_EXPORT_FORM_NAME =
  'UNIVERSAL_DATA_EXPORT_FORM_NAME';
export const ZERO_NEGATIVE_BALANCE_FORM_NAME =
  'ZERO_NEGATIVE_BALANCE_FORM_NAME';
export const PROVISION2_FORM_NAME = 'PROVISION2_FORM_NAME';
export const PROVISION_2_BASE_RATES_SETUP_FORM_NAME =
  'PROVISION_2_BASE_RATES_SETUP_FORM_NAME';
export const CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME =
  'CREATE_EDIT_TRUCK_ROUTE_SCHEDULE_FORM_NAME';
export const TRUCK_ROUTE_REPORT_FORM_NAME = 'TRUCK_ROUTE_REPORT_FORM_NAME';
export const PRODUCTION_GRID_FORM_NAME = 'PRODUCTION_GRID_FORM_NAME';
export const CLOSE_PRODUCTION_FORM_NAME = 'CLOSE_PRODUCTION_FORM_NAME';
export const EXPORT_TOTALS_FORM_NAME = 'EXPORT_TOTALS_FORM_NAME';
export const SECOND_REVIEW_DETAILS_FORM_NAME =
  'SECOND_REVIEW_DETAILS_FORM_NAME';
export const FNS874_REPORT_FORM_NAME = 'FNS874_REPORT_FORM_NAME';
export const APPLICATION_HUB_REPROCESS_MEALS_FORM_NAME =
  'APPLICATION_HUB_REPROCESS_MEALS_FORM_NAME';
export const RECIPE_PREPARATION_FILTERS_FORM_NAME =
  'RECIPE_PREPARATION_FILTERS_FORM_NAME';
export const RECIPE_PREPARATION_TABLE_FORM_NAME =
  'RECIPE_PREPARATION_TABLE_FORM_NAME';
export const VIEW_APPLICATION_DISTRIBUTION_FORM_NAME =
  'VIEW_APPLICATION_DISTRIBUTION_FORM_NAME';
export const DAILY_DEPOSIT_FILTERS_FORM_NAME =
  'DAILY_DEPOSIT_FILTERS_FORM_NAME';
export const NEW_YORK_SIRS_EXPORT_FORM_NAME = 'NEW_YORK_SIRS_EXPORT_FORM_NAME';
export const NEW_YORK_SIRS_AUTO_EXPORT_FORM_NAME =
  'NEW_YORK_SIRS_AUTO_EXPORT_FORM_NAME';
export const IPRANGE_ENTRY_FORM_NAME = 'IPRANGE_ENTRY_FORM_NAME';
export const MEALS_PER_LABOR_HOUR_FORM_NAME = 'MEALS_PER_LABOR_HOUR_FORM_NAME';
export const VENDORLINK_CONFIGURATION_FORM_NAME =
  'VENDORLINK_CONFIGURATION_FORM_NAME';
export const VENDORLINK_MAPPINGS_FORM_NAME = 'VENDORLINK_MAPPINGS_FORM_NAME';
export const VENDORLINK_PREVIEW_FORM_NAME = 'VENDORLINK_PREVIEW_FORM_NAME';
export const SC_SLP_FORM_NAME = 'SC_SLP_FORM_NAME';
export const NC_SFS_4_FORM_NAME = 'NC_SFS_4_FORM_NAME';
export const PRINT_PRODUCTION_MODAL_FORM_NAME =
  'PRINT_PRODUCTION_MODAL_FORM_NAME';
export const VENDING_MACHINE_ENTRY_FORM_NAME =
  'VENDING_MACHINE_ENTRY_FORM_NAME';
export const FILE_CONFIGURATIONS_FORM_NAME = 'FILE_CONFIGURATIONS_FORM_NAME';
export const SCHOOL_SITE_ORDER_FORM_NAME = 'SCHOOL_SITE_ORDER_FORM_NAME';
export const APPLIED_MENU_CONFIG_FORM_NAME = 'APPLIED_MENU_CONFIG_FORM_NAME';
export const EXTENDED_BENEFITS_FORM_NAME = 'EXTENDED_BENEFITS_FORM_NAME';
export const ITEM_COSTING_REPORT_FORM_NAME = 'ITEM_COSTING_REPORT_FORM_NAME';
export const SALES_ANALYSIS_REPORT_FORM_NAME =
  'SALES_ANALYSIS_REPORT_FORM_NAME';
export const INGREDIENT_LISTING_REPORT_FORM_NAME =
  'INGREDIENT_LISTING_REPORT_FORM_NAME';
export const SIMPLE_AVERAGE_FORM_NAME = 'SIMPLE_AVERAGE_FORM_NAME';
export const FOOD_BASED_ANALYSIS_FORM_NAME = 'FOOD_BASED_ANALYSIS_FORM_NAME';
export const DISCONTINUED_INGREDIENTS_REPORT_FORM_NAME =
  'DISCONTINUED_INGREDIENTS_REPORT_FORM_NAME';
export const RECIPE_LISTING_FORM_NAME = 'RECIPE_LISTING_FORM_NAME';
export const GA_CASH_INCOME_FORM_NAME = 'GA_CASH_INCOME_FORM_NAME';
export const NUTRIENT_ANALYSIS_REPORT_FORM_NAME =
  'NUTRIENT_ANALYSIS_REPORT_FORM_NAME';

export const DEFAULT_LABOR_HOURS_FORM_NAME = 'DEFAULT_LABOR_HOURS_FORM_NAME';
export const AERIES_CONFIGURATION_FORM_NAME = 'AERIES_CONFIGURATION_FORM_NAME';
export const AERIES_MAPPINGS_FORM_NAME = 'AERIES_MAPPINGS_FORM_NAME';
export const AERIES_PREVIEW_FORM_NAME = 'AERIES_PREVIEW_FORM_NAME';
export const TAX_RATE_ENTRY_FORM_NAME = 'TAX_RATE_ENTRY_FORM_NAME';
export const ASSIGN_TAX_SITES_FORM_NAME = 'ASSIGN_TAX_SITES_FORM_NAME';

export const VIRGINIA_CLAIM_REPORT_FORM_NAME =
  'VIRGINIA_CLAIM_REPORT_FORM_NAME';
export const PRODUCTION_REPORT_SETUP_CREATE_NEW_REPORT_FORM_NAME =
  'PRODUCTION_REPORT_SETUP_CREATE_NEW_REPORT_FORM_NAME';
export const PRODUCTION_REPORT_SETUP_CREATE_REPORT_TEMPLATE =
  'PRODUCTION_REPORT_SETUP_CREATE_REPORT_TEMPLATE';
export const NUTRITION_STANDARDS_REPORT_FORM_NAME =
  'NUTRITION_STANDARDS_REPORT_FORM_NAME';
export const STUDENT_NOTES_REPORT_FORM_NAME = 'STUDENT_NOTES_REPORT_FORM_NAME'


// WEBPACK FOOTER //
// ./src/common/FormEnum.js